import React, { useState, useEffect } from "react"
import { Drawer, Box, IconButton, Typography, Button, InputAdornment, TextField } from '@mui/material';
import { CloseSquare, AddCircle, ArrowSquareLeft, SearchNormal, ArrowCircleRight } from 'iconsax-react';
import styles from '../my-data.module.scss';
import RoundButton from "../../content/shared/components/round-btn";
import { LoadingButton } from "@mui/lab";
import LanguageItem from "./language-item";
import DeleteLangModal from "./delete-lang-modal";

const LanguageMenu = ({ show, setShow, window, language, setLanguage, uiStore, page }) => {

    const container = window !== undefined ? () => window().document.body : undefined;
    const [showAllLanguages, setShowAllLangauges] = useState(false);
    const { languages, userLanguages } = uiStore;
    const [newLang, setNewLang] = useState('');
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedLang, setSelectedLang] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        if (page !== 'edit-card')
            uiStore?.fetchAllLanguages();
    }, [page, uiStore]);

    const handlePrimary = async (lang) => {
        setLoading(true);
        await uiStore.makeLangPrimary(lang);
        setLoading(false);
    };

    const addLang = async () => {
        setLoading(true);

        if (selectedLang) {
            await uiStore.switchLang(newLang, selectedLang._id, selectedLang.language);
        } else {
            await uiStore.addLang(newLang);
        }

        if (selectedLang?.language === language?.language)
            setLanguage(newLang)

        toggleShowLanguages();
        setLoading(false);
    };

    const deleteLangFeedback = async () => {
        if (selectedLang === language?.language)
            setLanguage(userLanguages.find(i => i.primary).language)
        setSelectedLang('');
    };

    const showDeleteLang = (lang) => {
        setSelectedLang(lang);
        setShowDeleteModal(true);
    }

    const switchLang = (lang) => {
        setSelectedLang(lang);
        toggleShowLanguages();
    }

    const toggleShowLanguages = () => {
        setNewLang('');
        setShowAllLangauges(val => !val);
    }

    return (
        <>
            <Drawer
                container={container}
                variant="temporary"
                open={show}
                onClose={() => setShow(false)}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', maxWidth: '370px', width: '90%' },
                }}
            >
                {showAllLanguages ?
                    <>

                        <Box sx={{ position: 'sticky', top: '0px', backgroundColor: '#fff', zIndex: '100' }}>
                            <Box sx={{ display: 'flex', mt: 3 }}>
                                <IconButton sx={{ ml: 1, mr: 2 }} onClick={toggleShowLanguages}>
                                    <ArrowSquareLeft
                                        size="36"
                                        color='#242333'
                                        variant='Bold'
                                    />
                                </IconButton>
                                <Box sx={{ mt: 2 }}>
                                    <Typography fontSize={18} fontWeight='700'>{selectedLang ? 'Switch Language' : 'Add Language'}</Typography>
                                </Box>

                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                                <TextField
                                    fullWidth
                                    size='small'
                                    placeholder='Search for language'
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchNormal
                                                    size="24"
                                                    variant="Bulk"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{ maxWidth: '300px' }}
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                />
                            </Box>
                        </Box>


                        <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: '10px' }}>
                            {languages.filter(lang => !userLanguages.find(i => i.language === lang))
                                .filter(lang => lang.toLowerCase().includes(query.toLowerCase()))
                                .map(lang =>
                                    <Button
                                        key={lang}
                                        sx={{ width: '90%', margin: '10px', justifyContent: 'flex-start' }}
                                        onClick={() => setNewLang(lang)}
                                        variant={newLang === lang ? 'contained' : ''}
                                        color={newLang === lang ? 'secondary' : ''}
                                    >
                                        {lang}
                                    </Button>
                                )}

                            <Box className={styles.dataDialougeActions} e>
                                <LoadingButton
                                    loading={!!loading}
                                    variant="contained"
                                    endIcon={
                                        <ArrowCircleRight
                                            size="24"
                                            variant="Bulk"
                                        />
                                    }
                                    onClick={addLang}
                                    disabled={!newLang}
                                >
                                    Save
                                </LoadingButton>
                            </Box>
                        </Box>

                    </>

                    :
                    <>
                        <Box className={styles.mobileMenuHeader}>
                            <Box sx={{ mt: 2 }}>
                                <Typography fontSize={18} fontWeight='700'>Info Language</Typography>
                                <Typography color='#888888'>Make cards in different languages</Typography>
                            </Box>
                            <IconButton sx={{ ml: 2, mr: 1 }} onClick={() => setShow(false)}>
                                <CloseSquare
                                    size="36"
                                    color='#242333'
                                    variant='Bold'
                                />
                            </IconButton>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: '10px' }}>
                            {userLanguages.map(
                                lang =>
                                    <LanguageItem
                                        key={lang._id}
                                        lang={lang}
                                        language={language}
                                        setLanguage={setLanguage}
                                        makePrimary={handlePrimary}
                                        switchLang={switchLang}
                                        deleteLang={showDeleteLang}
                                        noActions={page === 'edit-card'}
                                        forceStopOption={false}
                                    />
                            )}
                        </Box>

                        {page !== 'edit-card' &&
                            <RoundButton
                                startIcon={
                                    <AddCircle
                                        size="24"
                                        variant="Bulk"
                                    />
                                }
                                variant="contained"
                                color="lightblue"
                                sx={{ mt: 3, ml: 2, width: '90%', justifyContent: 'flex-start' ,bottom: '10px',position: 'sticky'}}
                                onClick={toggleShowLanguages}
                            >
                                Add Language
                            </RoundButton>
                        }
                    </>
                }

            </Drawer>

            <DeleteLangModal
                lang={selectedLang}
                feedback={deleteLangFeedback}
                show={showDeleteModal}
                setShow={setShowDeleteModal}
                uiStore={uiStore}
            />
        </>
    );
}

export default LanguageMenu;